import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ModalContainer } from '@flyfreely-portal-ui/ngx-bootstrap-customisation';
import { ProfileDialogueComponent } from '../profile-dialogue.component';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: '',
                component: ModalContainer,
                data: {
                    modalContent: ProfileDialogueComponent,
                    modalClass: 'modal-lg'
                }
            }
        ])
    ],
    exports: [RouterModule]
})
export class UserProfileRoutingModule {}
